import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MailService {
  constructor() {}

  async sendMail(payload) {
    console.log(payload);
    let response = await fetch(
      'https://5vbuahwstg.execute-api.eu-west-1.amazonaws.com/prod/service',
      {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tid: payload.tid,
          uid: payload.uid,
          creator: payload.creator,
          mail: payload.mail,
          phone: payload.phone,
          name: payload.name,
          category: payload.category,
          description: payload.description,
          address: payload.address,
          images: payload.images,
        }),
      }
    );
    return await response.json();
  }
}
